import {
    IUiChannel,
    MessageBroker,
    MyAccountTab,
    PostLoginActionNameEnum,
    IDialogOptionsData,
} from '@sparkware/uc-sdk-core';
import Container from 'typedi';
import PostLoginApi from '../../../../APIs/PostLoginApi';
import { LoggerProvider } from '../../logger';
import DialogType from '../../ui/enums/DialogType';
import {
    IPostLoginActionsState,
    IUploadDocumentsPostLoginOptions,
} from '../models/IPostLoginActionsState';
import { PostLoginActionBase } from './post-login-action-base';
import { IPlayer } from '../../player/models';
import { LoaderManager } from '../../../loaders/LoaderManager';

export class UploadDocumentsPostLoginAction extends PostLoginActionBase {
    private _uiChannel: IUiChannel;

    private get _playerPromise(): Promise<IPlayer> {
        return LoaderManager.Instance.PlayerLoader.Instance;
    }

    constructor(state: IPostLoginActionsState) {
        super(PostLoginActionNameEnum.UploadDocuments, 'UploadDocumentsPostLoginAction', state);
        this._logger = Container.get(LoggerProvider).getLogger('UploadDocumentsPostLoginAction');
        this._uiChannel = MessageBroker.getInstance().ui;
    }

    protected override canExecute = async (
        options?: IUploadDocumentsPostLoginOptions,
    ): Promise<boolean> => {
        let canExecute = false;
        if (!options?.enabled) {
            return false;
        }

        const { response } = await PostLoginApi.CheckIfTempUser();

        if (response) {
            const { response: documentsDisplayed } =
                await PostLoginApi.UploadDocumentsAlreadyDisplayed();

            canExecute = !documentsDisplayed;
        }

        return canExecute;
    };

    protected override doAction = async (
        options?: IUploadDocumentsPostLoginOptions,
    ): Promise<boolean> => {
        const { daysToUploadDocuments } = this._window.pageContextManager.getUserData();
        const { isHighRiskCountry } = this._window.pageContextManager.getUserData();

        const dialogOptions: IDialogOptionsData = {
            contentValues: {
                daysToUpload: daysToUploadDocuments,
                isHighRiskCountry: isHighRiskCountry,
            },
        };

        if (options.skipUploadDocumentsPopUp) {
            const player = await this._playerPromise;
            if (player) {
                player.onMyAccountOpen({
                    tabId: MyAccountTab.UploadDocuments,
                    hideHeader: true,
                    hideMenu: true,
                    showInAppCloseButton: true,
                    onClose: () => {
                        this.completeAction();
                    },
                });
            }
        } else {
            this._uiChannel.topics.DialogShow.publish(
                {
                    publisher: 'UploadDocumentsPostLoginAction',
                },
                {
                    dialogType: DialogType.UploadDocuments,
                    options: dialogOptions,
                },
            );
        }
        return false;
    };
}
